const formatTime = (t) => {
	return t < 10 ? '0' + t : t
}

class CountDown {
	constructor(expiredDate, onRender, onComplete) {
		this.setExpiredDate(expiredDate);

		this.onRender = onRender
		this.onComplete = onComplete
	}

	setExpiredDate(expiredDate) {
		if (!expiredDate) return

		const currentTime = new Date().getTime()

		this.timeRemaining = expiredDate.getTime() - currentTime

		this.timeRemaining <= 0 ? this.complete() : this.start()
	}

	complete() {
		if (typeof this.onComplete === 'function') {
			this.onComplete()
		}
	}

	getTime() {
		return {
			days: Math.floor(this.timeRemaining / 1000 / 60 / 60 / 24),
			hours: Math.floor(this.timeRemaining / 1000 / 60 / 60) % 24,
			minutes: Math.floor(this.timeRemaining / 1000 / 60) % 60,
			seconds: Math.floor(this.timeRemaining / 1000) % 60
		};
	}

	update() {
		if (typeof this.onRender === 'function') {
			this.onRender(this.getTime());
		}
	}

	start(pause = false) {
		// update the countdown
		this.update();

		//  setup a timer
		this.intervalId = setInterval(() => {
			// update the timer
			this.timeRemaining -= 1000;

			if (this.timeRemaining < 0) {
				// call the callback
				this.complete();

				// clear the interval if expired
				clearInterval(this.intervalId);
			} else {
				this.update();
			}

		}, 1000);

		if (pause) {
			clearInterval(this.intervalId)
		}
	}

	stop() {
		console.log('paused')
		clearInterval(this.intervalId)
	}
}